const initialState = {
  language: "English",
  currency: "USD",
  code: "en",
};

export const localeReducer = (state = initialState, action) => {
  switch (action.type) {
    case "SET_LOCALE":
      return action.payload;
    default:
      return state;
  }
};
